import React, { useContext } from 'react';
import useSectionStyles from './styles';
import arrowDown from '../../images/arrowDown.svg';
import Button from '../button/index';
import Dropdown from '../dropdown';
import PageContext from '../../contexts/pageContext';
import playStore from '../../assets/images/Play Store.svg';
import appStore from '../../assets/images/App Store.svg';
import downloadApkImage from '../../assets/images/download.png';
import { getAppDownloadLink } from '../../utils';

export default function OptionList({
  optionsData,
  headerData,
  isMobile,
  moreContent,
  navDataCount,
  isTutorWebsite,
  isLandingPages,
  onDownloadAppTriggered
}) {
  const { isPreview, countryCode } = useContext(PageContext);

  function checkIsActiveTab(slug = '') {
    if (typeof window !== 'undefined') {
      const pathname = window.location.pathname;
      const slugFromPathname = pathname?.split('/')[1];
      if (slug && slugFromPathname.includes(slug)) {
        return true;
      } else {
        return false;
      }
    }
  }

  const tabsDataModifier = () => {
    return optionsData?.map((dt) => {
      return {
        value: dt.title,
        link: dt.slug,
        active: checkIsActiveTab(dt.slug),
        isLink: true,
        isExternal: 0
      };
    });
  };

  const tabData = tabsDataModifier();

  const classes = useSectionStyles();

  // console.log(headerData, 'sakshat header options');

  const isAndroidDelisted = headerData?.isAndroidDelisted;
  const apkURL = headerData?.apkURL;

  const downloadApkURL = isAndroidDelisted && apkURL ? apkURL : null;
  const downloadAppText = countryCode === 'KR' ? '앱다운로드' : 'Download App';

  const renderDownloadAppButton = () => {
    return (
      <>
        {apkURL && (
          <a
            href={headerData?.apkURL}
            target="_blank"
            className={classes.socialBtnItems}
            onClick={() => {
              if (typeof onDownloadAppTriggered == 'function') {
                onDownloadAppTriggered(isAndroidDelisted, headerData?.apkURL);
              }
            }}
          >
            <img
              style={{ width: '139px', borderRadius: '8px' }}
              src={downloadApkImage}
              alt="download-apk"
            />
          </a>
        )}
        {headerData?.iosUrl ? (
          <a
            target="_blank"
            href={headerData?.iosUrl}
            className={classes.socialBtnItems}
          >
            <img src={appStore} alt="appStore" />
          </a>
        ) : null}
      </>
    );
  };

  const renderAppDownloadLinks = () => {
    return (
      <div className={classes.socialBtn}>
        {headerData?.androidURL ? (
          <a
            href={headerData?.androidURL}
            target="_blank"
            className={classes.socialBtnItems}
          >
            <img src={playStore} alt="playStore" />
          </a>
        ) : null}
        {headerData?.iosUrl ? (
          <a
            target="_blank"
            href={headerData?.iosUrl}
            className={classes.socialBtnItems}
          >
            <img src={appStore} alt="appStore" />
          </a>
        ) : null}
      </div>
    );
  };

  const iosLink = isTutorWebsite
    ? headerData?.iosDownloadLink
    : headerData?.iosUrl;

  const androidLink = isTutorWebsite
    ? headerData?.androidDownloadLink
    : headerData?.appLink;

  // console.log(iosLink, 'sakshat ios link');
  // console.log(androidLink, 'sakshat android link');

  return (
    <div className={classes.listSection}>
      <div className={classes.optionsContainer}>
        <div className={classes.optionList}>
          {tabData?.map((dt, ind) => {
            return (
              <Button
                key={ind}
                data={dt}
                type={'tertiary'}
                size={isMobile ? 'small' : 'large'}
                styling={
                  isMobile ? { padding: '20px 40px' } : { margin: '0 10px' }
                }
                active={dt.active}
              />
            );
          })}
        </div>
        {navDataCount > 5 && !isMobile ? (
          <Dropdown list={moreContent} label={'More'} icon={arrowDown} />
        ) : null}

        {isTutorWebsite && (
          <>
            {isAndroidDelisted && !headerData.navs ? (
              <>{renderDownloadAppButton()}</>
            ) : (
              <>{!headerData?.navs && renderAppDownloadLinks()}</>
            )}
          </>
        )}

        {isMobile ? (
          downloadApkURL?.length > 0 ||
          androidLink?.length > 0 ||
          iosLink?.length > 0 ? (
            <Button
              data={{
                link: isAndroidDelisted
                  ? getAppDownloadLink(downloadApkURL, iosLink)
                  : getAppDownloadLink(androidLink, iosLink),
                isLink: 1,
                value: downloadAppText,
                isExternal: 1
              }}
              type={'primary'}
              size={'small'}
              target={'blank'}
              rel={null}
              styling={isMobile ? { margin: '0 40px' } : {}}
            />
          ) : null
        ) : headerData?.loginCtaLink ? (
          <Button
            data={{
              link: headerData?.loginCtaLink,
              isLink: 1,
              value: countryCode === 'KR' ? '로그인' : 'Login',
              isExternal: 1
            }}
            type={'primary'}
            size={isMobile ? 'small' : 'medium'}
            target={null}
            rel={null}
            styling={isMobile ? { margin: '0 40px' } : {}}
          />
        ) : null}
      </div>
    </div>
  );
}
